import { About } from "../components/About";
import { FunFacts } from "../components/FunFacts";
import { Footer } from "../components/Footer";

export const AboutPage = ({ musicOn, onToggleMusic, onOpenContact }) => {
  return (
    <div className="page-about">
      <About />
      <FunFacts musicOn={musicOn} onToggleMusic={onToggleMusic} />
      <Footer onOpenContact={onOpenContact} />
    </div>
  );
};
